import './helpers/setup-csp.mts';
import 'shared/styles/index.less';

import {ConfigProvider} from 'antd';
import locale from 'antd/es/locale/ru_RU';
import moment from 'moment';
import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import {store} from 'store/config';

import {AppRoutes} from './app-routes';
import {AxiosInterceptorsInjector} from './axios-interceptors-injector';

import 'moment/locale/ru';

moment.locale('ru');

const root = document.getElementById('root') as HTMLElement;

async function initApp() {
    try {
        const {createMetadataMockInterceptors} = await import(
            'app/metadata-mock-interceptors/metadata-mock-interceptors'
        );
        await createMetadataMockInterceptors();
    } catch (error) {
        console.error('Ошибка при попытке инициализации metadata mock interceptors', error);
    }
}

initApp().then(() => {
    import('react-dom').then(ReactDOM => {
        ReactDOM.render((
            <Provider store={store}>
                <ConfigProvider
                    locale={locale}
                    csp={{nonce: process.env.REACT_APP_NONCE}}
                >
                    <BrowserRouter basename="/">
                        <AxiosInterceptorsInjector />
                        <AppRoutes />
                    </BrowserRouter>
                </ConfigProvider>
            </Provider>
        ), root);
    });
});
